/* Keep Upcart's own products, triggers and checkout; share the theme's styling. */
(function () {
  'use strict';
  var script = document.currentScript;
  var stylesheet = script && script.dataset.upcartStylesheet;
  var shopAll = script && script.dataset.shopAll;
  if (!stylesheet || !shopAll) return;


  function mount() {
    var host = document.getElementById('upCart');
    var root = host && host.shadowRoot;
    if (!root) return false;
    if (!host.dataset.cbCartEvents && typeof window.upcartSubscribeCartOpened === 'function') {
      window.upcartSubscribeCartOpened(function () {
        document.dispatchEvent(new CustomEvent('drawerOpen'));
      });
      host.dataset.cbCartEvents = 'true';
    }
    if (!root.querySelector('#cb-upcart-styles')) {
      var link = document.createElement('link');
      link.id = 'cb-upcart-styles';
      link.rel = 'stylesheet';
      link.href = stylesheet;
      root.appendChild(link);
    }
    function updateLinks() {
      root.querySelectorAll('a[href]').forEach(function (link) {
        var url = new URL(link.href, window.location.origin);
        if (url.origin === window.location.origin && /\/collections\/?$/.test(url.pathname)) link.href = shopAll;
      });
    }
    updateLinks();
    if (!host.dataset.cbExperience) {
      host.dataset.cbExperience = 'true';
      new MutationObserver(function (records) {
        if (records.some(function (record) { return record.addedNodes.length > 0; })) updateLinks();
      }).observe(root, { childList: true, subtree: true });
    }
    return true;
  }
  function init() {
    if (mount()) return;
    var observer = new MutationObserver(function () {
      if (mount()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true });
    window.addEventListener('load', function () {
      if (mount()) observer.disconnect();
    }, { once: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

(function () {
  'use strict';
  var template = document.getElementById('cb-free-cap-template');
  var strings = document.getElementById('cb-free-cap-strings');
  if (!template || !strings) return;
  var copy = JSON.parse(strings.textContent);
  var mark = '119-v1';
  var capIds = [54731510382925, 54731509858637];
  var giftTemplate = template.content.querySelector('[data-cb-cart-root]');
  var threshold = Number(giftTemplate.dataset.threshold) || 11900;
  var fullTracksuitIds = (giftTemplate.dataset.tracksuitIds || '').split(',').map(Number);
  var hoodieIds = (giftTemplate.dataset.hoodieIds || '').split(',').map(Number);
  var pantsIds = (giftTemplate.dataset.pantsIds || '').split(',').map(Number);
  var shippingThreshold = 7500;
  var root, panel, cart, timer;
  var busy = false, syncing = false, pending = false, subscribed = false;
  var changing = false, nativeCartUpdated = false;
  var queuedVariantId = null;
  var cartRoot = giftTemplate.dataset.cbCartRoot;

  function gift(item) {
    return capIds.indexOf(Number(item.variant_id)) !== -1 && item.properties && (item.properties._cb_free_cap === mark || item.properties._cb_free_cap === '150-v1');
  }
  function paidTotal(value) {
    return Math.max(0, value.total_price - value.items.reduce(function (sum, item) {
      return sum + (gift(item) || item.gift_card ? item.final_line_price : 0);
    }, 0));
  }
  function hasProduct(value, ids) {
    return value.items.some(function (item) {
      return item.quantity > 0 && ids.indexOf(Number(item.product_id)) !== -1;
    });
  }
  function hasFullTracksuit(value) {
    return hasProduct(value, fullTracksuitIds) || (hasProduct(value, hoodieIds) && hasProduct(value, pantsIds));
  }
  function qualifies(value) { return hasFullTracksuit(value) || (value.currency === 'EUR' && paidTotal(value) >= threshold); }
  function freeCap(value) {
    return value.items.find(function (item) {
      return capIds.indexOf(Number(item.variant_id)) !== -1 && item.final_line_price === 0 && item.quantity === 1;
    });
  }
  async function request(path, data) {
    var options = {credentials: 'same-origin', headers: {'Accept': 'application/json'}};
    if (data) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(data);
    } else options.cache = 'no-store';
    var response = await fetch(cartRoot + 'cart' + path + '.js', options);
    var result = await response.json();
    if (!response.ok) throw new Error(result.description || copy.error);
    return result;
  }
  function feedback(message) {
    if (!panel) return;
    var target = panel.querySelector('[data-cb-feedback]');
    target.textContent = message || '';
    target.hidden = !message;
  }
  function money(amount) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: 'EUR', maximumFractionDigits: amount % 100 ? 2 : 0}).format(amount / 100);
  }
  function render() {
    if (!panel || !cart) return;
    panel.hidden = cart.items.length === 0;
    panel.setAttribute('aria-busy', busy ? 'true' : 'false');
    var paid = paidTotal(cart);
    var eligible = qualifies(cart);
    var chosen = freeCap(cart);
    var text = hasFullTracksuit(cart) ? copy.tracksuit_unlocked : eligible ? copy.unlocked : cart.currency !== 'EUR' ? copy.currency : paid < shippingThreshold ? copy.shipping_remaining.replace('{amount}', money(shippingThreshold-paid)) : copy.cap_remaining.replace('{amount}', money(threshold-paid));
    panel.querySelector('[data-cb-progress]').textContent = text;
    panel.querySelector('[data-cb-shipping-fill]').style.width = Math.min(100, paid / shippingThreshold * 100) + '%';
    panel.querySelector('[data-cb-cap-fill]').style.width = (hasFullTracksuit(cart) ? 100 : Math.min(100, Math.max(0, paid - shippingThreshold) / (threshold - shippingThreshold) * 100)) + '%';
    panel.querySelector('[data-cb-choices]').hidden = !eligible;
    panel.querySelector('[data-cb-selected]').hidden = !chosen || changing;
    panel.querySelector('[data-cb-picker]').hidden = !!chosen && !changing;
    if (chosen) {
      var selectedButton = panel.querySelector('[data-cb-cap="' + chosen.variant_id + '"]');
      panel.querySelector('[data-cb-selected-name]').textContent = selectedButton ? selectedButton.querySelector('.cb-gift__name').textContent : chosen.product_title;
    }
    panel.querySelectorAll('[data-cb-cap]').forEach(function (button) {
      var selected = chosen && Number(button.dataset.cbCap) === Number(chosen.variant_id);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.disabled = busy || button.dataset.cbAvailable !== 'true';
      button.querySelector('[data-cb-action]').textContent = selected ? copy.selected : button.dataset.cbAvailable === 'true' ? copy.choose : copy.sold_out;
    });
  }
  async function refreshDrawer() {
    if (typeof window.upcartRefreshCart === 'function') await window.upcartRefreshCart();
    document.dispatchEvent(new CustomEvent('cart:build'));
  }
  async function reconcile(value) {
    var gifts = value.items.filter(gift);
    var remove = !qualifies(value);
    var kept = false;
    for (var i=0; i<gifts.length; i++) {
      var item = gifts[i];
      var quantity = remove || kept ? 0 : 1;
      kept = true;
      if (item.quantity !== quantity) {
        value = await request('/change', {id:item.key, quantity:quantity});
        if (remove) feedback(copy.removed);
      }
    }
    var chargedGifts = value.items.filter(function (item) { return gift(item) && item.final_line_price > 0; });
    for (var j=0; j<chargedGifts.length; j++) {
      value = await request('/change', {id:chargedGifts[j].key, quantity:0});
      feedback(copy.discount_error);
    }
    return value;
  }
  function schedule() {
    pending = true;
    clearTimeout(timer);
    if (!busy && !syncing) timer = setTimeout(sync, 120);
  }
  async function sync() {
    if (busy || syncing) return;
    syncing = true;
    pending = false;
    var refreshNativeCart = nativeCartUpdated;
    nativeCartUpdated = false;
    try {
      var value = await request('');
      var before = JSON.stringify(value.items.map(function(item){return [item.key,item.quantity];}));
      if (qualifies(value)) feedback('');
      cart = await reconcile(value);
      if (refreshNativeCart || before !== JSON.stringify(cart.items.map(function(item){return [item.key,item.quantity];}))) await refreshDrawer();
      render();
    } catch (error) { feedback(copy.error); }
    finally {
      syncing = false;
      if (queuedVariantId !== null) {
        var nextVariantId = queuedVariantId;
        queuedVariantId = null;
        choose(nextVariantId);
      } else if (pending) schedule();
    }
  }
  async function choose(variantId) {
    if (busy) return;
    if (syncing) { queuedVariantId = variantId; feedback(copy.updating); return; }
    busy = true;
    clearTimeout(timer);
    feedback(copy.updating);
    render();
    try {
      cart = await request('');
      if (!qualifies(cart)) { cart = await reconcile(cart); feedback(copy.removed); return; }
      var current = freeCap(cart);
      if (current && Number(current.variant_id) === variantId) { changing = false; feedback(''); return; }
      var existing = cart.items.filter(gift);
      if (current && !gift(current)) existing.push(current);
      for (var i=0;i<existing.length;i++) cart = await request('/change',{id:existing[i].key,quantity:0});
      await request('/add',{items:[{id:variantId,quantity:1,properties:{_cb_free_cap:mark}}]});
      cart = await request('');
      var selected = cart.items.find(function(item){return gift(item) && Number(item.variant_id)===variantId;});
      if (!selected || selected.final_line_price !== 0 || !qualifies(cart)) {
        if (selected) cart = await request('/change',{id:selected.key,quantity:0});
        feedback(copy.discount_error);
      } else { changing = false; feedback(''); }
    } catch (error) { feedback(copy.error); }
    finally {
      try { await refreshDrawer(); } catch (error) {}
      busy = false;
      render();
      if (pending) schedule();
    }
  }
  function mount() {
    var host = document.getElementById('upCart');
    root = host && host.shadowRoot;
    if (!root) return false;
    if (!host.dataset.cbGiftObserver) {
      host.dataset.cbGiftObserver = 'true';
      new MutationObserver(mount).observe(root,{childList:true,subtree:true});
    }
    var body = root.querySelector('.upcart-cart-body');
    if (!body) return false;
    root.querySelectorAll('.upcart-public-product-properties__item').forEach(function(property) {
      if (property.textContent.trim().indexOf('_cb_free_cap:') !== 0) return;
      property.classList.add('cb-gift-private');
      var tile = property.closest('.upcart-public-component-product-tile');
      if (tile) tile.classList.add('cb-gift-line');
    });
    if (!root.querySelector('.cb-gift')) {
      var fragment = template.content.cloneNode(true);
      panel = fragment.querySelector('.cb-gift');
      var rewards = body.querySelector('.upcart-public-rewards');
      if (rewards) rewards.before(fragment); else body.prepend(fragment);
      panel.addEventListener('click', function (event) {
        if (event.target.closest('[data-cb-change]')) { changing = true; render(); return; }
        var button = event.target.closest('[data-cb-cap]');
        if (button && !button.disabled) choose(Number(button.dataset.cbCap));
      });
      body.classList.add('cb-gift-enabled');
      render();
      schedule();
    }
    if (!subscribed && typeof window.upcartSubscribeCartUpdated === 'function') {
      subscribed = true;
      window.upcartSubscribeCartLoaded(schedule);
      window.upcartSubscribeCartUpdated(schedule);
      window.upcartSubscribeCartOpened(schedule);
      root.addEventListener('click', guardCheckout, true);
    }
    return true;
  }
  async function checkCheckout(resume) {
    if (busy || syncing) { feedback(copy.updating); return; }
    busy = true;
    clearTimeout(timer);
    pending = false;
    feedback(copy.updating);
    var ready = false;
    try {
      var value = await request('');
      var before = JSON.stringify(value.items.map(function (item) { return [item.key, item.quantity]; }));
      cart = await reconcile(value);
      if (before !== JSON.stringify(cart.items.map(function (item) { return [item.key, item.quantity]; }))) await refreshDrawer();
      ready = !cart.items.some(function (item) { return gift(item) && item.final_line_price > 0; });
      feedback(ready ? '' : copy.discount_error);
    } catch (error) { feedback(copy.error); }
    finally { busy = false; render(); }
    if (ready) resume();
    else if (pending) schedule();
  }
  function guardCheckout(event) {
    var target = event.target.closest('a[href*="/checkout"],a[href*="/cart/c/"],button[name="checkout"],.upcart-checkout-button,.upcart-public-checkout-button');
    if (!target || target.dataset.cbCheckoutReady === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkCheckout(function () {
      target.dataset.cbCheckoutReady = 'true';
      target.click();
      delete target.dataset.cbCheckoutReady;
    });
  }
  document.addEventListener('click', guardCheckout, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout' || submitter.dataset.cbCheckoutReady === 'true' || form.dataset.cbCheckoutReady === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkCheckout(function () {
      form.dataset.cbCheckoutReady = 'true';
      form.requestSubmit(submitter);
      delete form.dataset.cbCheckoutReady;
    });
  }, true);
  document.addEventListener('cart:updated', function () {
    nativeCartUpdated = true;
    schedule();
  });
  document.addEventListener('drawerOpen', mount);
  if (!mount()) {
    var observer = new MutationObserver(function(){if(mount()) observer.disconnect();});
    observer.observe(document.body,{childList:true,subtree:true});
    window.addEventListener('load',mount,{once:true});
  }
})();
